module.exports = __webpack_public_path__ + "static/media/About_Section.18e0fc32.jpg";